import { render, staticRenderFns } from "./newsPush.vue?vue&type=template&id=62088464&"
import script from "./newsPush.vue?vue&type=script&lang=js&"
export * from "./newsPush.vue?vue&type=script&lang=js&"
import style0 from "./newsPush.vue?vue&type=style&index=0&id=62088464&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports